import styles from './TransactionItem.module.css'
import ExceptionItem from '../ExceptionItem/ExceptionItem'
import {
    getDayName,
    getMonthName,
    formatCurrency,
} from '../../utilities/general-utils'
import { IconStarFilled, IconCheckmark, IconCalendarFirst, IconSnowball } from '../../assets/icons'

const TransactionItem = ({item, hideBalance = false }) => {
    const isNegativeBalance = !hideBalance ? item.balance < 0 : false
    const isLowBalance = !hideBalance ? item.balance >= 0 && item.balance < 500 : false
    const isDebitTransaction = item.amount < 0

    return (
        <div
            className={`${styles.item} ${isLowBalance ? styles.lowBalance: '' } ${isNegativeBalance ? styles.negativeBalance : ''}`}
        >
            <div className={styles.itemDate}>
                <DateTile date={item.instanceDate} />
            </div>

            <div className={styles.itemInfoWrap}>
                <div className={styles.itemTitle}>
                    {item.title}
                </div>
                <div className={styles.itemCategory}>
                    {item.category}
                </div>
                <div className={styles.itemAccount}>
                    <AccountDisplay accountName={item.accountName} accountType={item.accountType} />
                </div>
            </div>
            
            <div className={styles.itemAmountWrap}>
                <div className={`${styles.itemAmount} ${isDebitTransaction ? styles.negativeAmount : ''}`}>
                    {formatCurrency(item.amount)}
                </div>
                {!hideBalance && (
                    <div className={`${styles.itemBalance} ${isNegativeBalance ? styles.negativeBalance : ''}`}>
                        {formatCurrency(item.balance)}
                    </div>
                )}
            </div>

            <div className={`${styles.itemIcons} ${item.exceptionItems ? styles.hasExceptions : ''} ${item.highlight ? styles.highlight : ''}`}>
                <ExceptionItem transaction={item} className={styles.itemIcon} />
                {!item.is_recurring && <IconStarFilled wrapperClass={styles.itemIcon} />}
                {item.isFirst && <IconCalendarFirst wrapperClass={styles.itemIcon} style={{backgroundColor: "#fff"}} />}
                {item.isLast && <IconCheckmark wrapperClass={styles.itemIcon} />}
                {item.is_snowball === 1 && <IconSnowball wrapperClass={styles.itemIcon} />}
            </div>
        </div>
    )
}

export default TransactionItem

const AccountDisplay = ({ accountName, accountType }) => {
    const includeDash = accountName && accountType;

    return (
        <span>
            {accountName} {includeDash ? ' - ' : ''} {accountType}
        </span>
    )
}

const DateTile = ({date}) => {
    const d = new Date(date)

    return (
        <div className={styles.itemDateTile}>
            <div className={styles.itemDateTileInner}>
                <div className={styles.itemDateTileDayOfWeek}>
                    {getDayName(d, true)}
                </div>
                <div className={styles.itemDateTileDay}>
                    {d.getDate()}
                </div>
                <div className={styles.itemDateTileMonth}>
                    {getMonthName(d, true)}
                </div>
            </div>
        </div>
    )
}